// extracted by mini-css-extract-plugin
export default {"Logo":"style_Logo__GAB+W","Logo__icon":"style_Logo__icon__hVM-T","Logo__caption":"style_Logo__caption__uO458"};